import {
  Breadcrumbs,
  Cards,
  Carousels,
  Collapses,
  Dropdowns,
  Forms,
  Jumbotrons,
  ListGroups,
  Navbars,
  Navs,
  Paginations,
  Popovers,
  ProgressBar,
  Switches,
  Tables,
  Tabs,
  Tooltips,
} from './framework/Base';

import { ButtonDropdowns, ButtonGroups, Buttons, BrandButtons } from './framework/Buttons';
import Charts from './framework/Charts';
import Dashboard from './framework/Dashboard';
import { Flags, FontAwesome, SimpleLineIcons } from './framework/Icons';
import { Alerts, Badges, Modals } from './framework/Notifications';
import { Login, Page404, Page500, Register } from './framework/Pages';
import { Colors, Typography } from './framework/Theme';
import Widgets from './framework/Widgets';

import Themis from './components/systems/themis/Themis'
import Cppro from './components/systems/cppro/Cppro'
import SpreadsheetMigration from './components/spreadsheet/SpreadsheetMigration'

export {
  Badges,
  Typography,
  Colors,
  Page404,
  Page500,
  Register,
  Login,
  Modals,
  Alerts,
  Flags,
  SimpleLineIcons,
  FontAwesome,
  ButtonDropdowns,
  ButtonGroups,
  BrandButtons,
  Buttons,
  Tooltips,
  Tabs,
  Tables,
  Charts,
  Dashboard,
  Widgets,
  Jumbotrons,
  Switches,
  ProgressBar,
  Popovers,
  Navs,
  Navbars,
  ListGroups,
  Forms,
  Dropdowns,
  Collapses,
  Carousels,
  Cards,
  Breadcrumbs,
  Paginations,
  Themis,
  Cppro,
  SpreadsheetMigration
};




// WEBPACK FOOTER //
// ./src/views/index.js